// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.label_input-group_GrLDU {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
}

.label_input-group-column_G_Pch {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
}

.label_input-group-column_G_Pch span {
    margin-bottom: .25rem;
}

.label_input-label_k2a2B, .label_input-label-secondary_Xx7e7 {
    font-size: 0.625rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: default;

    white-space: nowrap;
}

[dir="ltr"] .label_input-label_k2a2B, [dir="ltr"] .label_input-label-secondary_Xx7e7 {
    margin-right: .5rem;
}

[dir="rtl"] .label_input-label_k2a2B, [dir="rtl"] .label_input-label-secondary_Xx7e7 {
    margin-left: .5rem;
}

.label_input-label_k2a2B {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/label.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;;IAEf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.input-group {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.input-group-column {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.input-group-column span {\n    margin-bottom: .25rem;\n}\n\n.input-label, .input-label-secondary {\n    font-size: 0.625rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: default;\n\n    white-space: nowrap;\n}\n\n[dir=\"ltr\"] .input-label, [dir=\"ltr\"] .input-label-secondary {\n    margin-right: .5rem;\n}\n\n[dir=\"rtl\"] .input-label, [dir=\"rtl\"] .input-label-secondary {\n    margin-left: .5rem;\n}\n\n.input-label {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-group": `label_input-group_GrLDU`,
	"inputGroup": `label_input-group_GrLDU`,
	"input-group-column": `label_input-group-column_G_Pch`,
	"inputGroupColumn": `label_input-group-column_G_Pch`,
	"input-label": `label_input-label_k2a2B`,
	"inputLabel": `label_input-label_k2a2B`,
	"input-label-secondary": `label_input-label-secondary_Xx7e7`,
	"inputLabelSecondary": `label_input-label-secondary_Xx7e7`
};
export default ___CSS_LOADER_EXPORT___;
